// extracted by mini-css-extract-plugin
export default {"feedbackModal":"FeedbackModal_feedbackModal__Oj8Uz","content":"FeedbackModal_content__vzSg5","title":"FeedbackModal_title__VoqOe","space":"FeedbackModal_space__HlQnT"};